"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dynamic = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _useSfraApi = _interopRequireDefault(require("../../hooks/useSfraApi"));
const _excluded = ["component", "className", "index"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const Dynamic = _ref => {
  let {
      component,
      className,
      index
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    pages
  } = (0, _useSfraApi.default)();
  const componentMapping = pages === null || pages === void 0 ? void 0 : pages.getComponentMapping();
  if (componentMapping && typeof componentMapping[component.type_id] !== 'undefined') {
    return /*#__PURE__*/_react.default.createElement(componentMapping[component.type_id], _objectSpread({
      data: component.data,
      regions: component.regions,
      custom: component.custom,
      index,
      className: component.className || '',
      componentID: component.id
    }, rest));
  }
  return /*#__PURE__*/_react.default.createElement(() => /*#__PURE__*/_react.default.createElement("div", null, "The component ", component.type_id, " has not been created yet."));
};
exports.Dynamic = Dynamic;